import { Box, HStack, Image, Text } from "@chakra-ui/react"
import { dateToFormat } from "../Utilities"
import { Partners } from "../partnershipData"

export const ClientInsightInformationBox = ({
	client,
	userPlus,
	referralInfo,
}) => {
	const partner = Partners.find((p) => p.id === userPlus?.partner)

	return (
		<Box
			bgColor="white"
			boxShadow="md"
			borderRadius="md"
			display="flex"
			position="relative"
		>
			<Image
				src={
					partner
						? `/assets/${partner.id}_house_banner_icon.svg`
						: "/assets/house_banner_icon.svg"
				}
				position={{ md: "absolute" }}
				display={{ base: "none", lg: "flex" }}
			/>
			<Image
				src={
					partner
						? `/assets/${partner.id}_house_banner_icon2.svg`
						: "/assets/house_banner_icon2.svg"
				}
				position="absolute"
				top="0"
				right="0"
				display={{ base: "flex", lg: "none" }}
			/>
			<Box
				display={{ lg: "flex" }}
				width={{ base: "100%", lg: "50%" }}
				justifyContent="space-between"
				p="20px"
				ml={{ lg: "125px" }}
				mt={{ base: "25px", lg: "0" }}
			>
				<Box ml={{ lg: "10px" }}>
					<HStack alignItems={{ base: "center", lg: "start" }}>
						<Image src="/assets/user_group.svg" />
						<Text fontWeight="semibold" fontSize="lg">
							Client Info
						</Text>
					</HStack>
					<Box mt={{ base: "5px", lg: "15px" }}>
						<Text>{client?.name ? client.name : client.email}</Text>
						{client?.name && <Text>{client.email}</Text>}
					</Box>
				</Box>
				<Box ml={{ lg: "10px" }} mt={{ base: "10px", lg: "0px" }}>
					<Text fontWeight="semibold" fontSize="lg">
						Invite Sent
					</Text>
					<Box mt={{ base: "5px", lg: "15px" }}>
						{dateToFormat(client._createdAt)}
					</Box>
				</Box>
				{referralInfo && (
					<Box ml={{ lg: "30px" }} mt={{ base: "10px", lg: "0px" }}>
						<Text fontWeight="semibold" fontSize="lg">
							Referred By
						</Text>
						<Box mt={{ base: "5px", lg: "15px" }}>
							<Text>{referralInfo?.name}</Text>
							<Text>{referralInfo?.email}</Text>
							{referralInfo?.phone && <Text>{referralInfo?.phone}</Text>}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	)
}
